// La UNIDAD con la que se asigna un plan. No es "a quien": el destinatario se
// elige en la pantalla de Asignaciones y vive en pagos_jugador_plan.
export const UNIDADES = ['jugador', 'familia', 'grupo']

export const PLAN_SCOPES = [
  { value: 'libre', label: 'Libre (cualquiera)', ayuda: 'Se puede asignar por jugador, familia o grupo.' },
  { value: 'grupo', label: 'Por grupo', ayuda: 'Solo se asigna eligiendo grupos completos.' },
  { value: 'familia', label: 'Por familia', ayuda: 'Solo se asigna eligiendo familias.' },
  { value: 'jugador', label: 'Individual', ayuda: 'Solo se asigna eligiendo jugadores uno por uno.' },
]

// 'todos' es el valor legado: significaba "todo el deporte de la temporada" y la
// migracion 20260818b lo convierte a 'libre'. Se tolera aqui por si algun registro
// se escapa, para que la UI no se quede sin etiqueta.
const normalizar = (scope) => (scope === 'todos' ? 'libre' : scope)

export const scopeLabel = (scope) =>
  PLAN_SCOPES.find((s) => s.value === normalizar(scope))?.label || '—'

export const unidadesDeScope = (scope) => {
  const s = normalizar(scope)
  if (s === 'libre') return [...UNIDADES]
  return UNIDADES.includes(s) ? [s] : []
}

export const scopeAdmiteUnidad = (scope, unidad) => unidadesDeScope(scope).includes(unidad)

// Evitar el error en vez de reportarlo: si el admin marco grupos, los planes
// "Individual" ni se listan.
export const planesCompatibles = (planes = [], unidad) =>
  (unidad ? planes.filter((p) => scopeAdmiteUnidad(p.scope, unidad)) : [])
